export const MOBILE_MODE = import.meta.env.VITE_MOBILE && import.meta.env.VITE_MOBILE === 'true';
export const APP_VERSION = import.meta.env.VITE_APP_VERSION;
export const API_URL = MOBILE_MODE ? process.env.VITE_API_URL || '' : '';

export const GDPR_LINK = "/api/user-manager/v1/files/media/GDPR_4DBALTDYN.pdf?view=true";
export const LEGAL_LINK = "/api/user-manager/v1/files/media/Legal_Notice_4DBALTDYN.pdf?view=true";
export const TERMS_LINK = "/api/user-manager/v1/files/media/4DBALTDYN_terms_and_conditions_FR_EN.pdf?view=true";

export const ESA_LINK = "https://www.esa.int";